import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/profileimg/mocker'

export default {
  getProfileimg (getTfolder) {
    let params = '?folder='
    if (getTfolder) {
      params += getTfolder.folder
    }
    if (isMock) return generator(mocker.filepath())
    return instance().get(endpoint + '/profileimg/getimage' + params)
  },
  postProfileimgSave (getTfolder, filename) {
    var saveParams = {
      folder: getTfolder.folder,
      filename: filename
    }
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/profileimg/postSave', saveParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/profileimg/index.js